import { render, staticRenderFns } from "./TncAgreement.vue?vue&type=template&id=3b9f92c6&scoped=true&"
import script from "./TncAgreement.vue?vue&type=script&lang=js&"
export * from "./TncAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TncAgreement.vue?vue&type=style&index=0&id=3b9f92c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f92c6",
  null
  
)

export default component.exports